import React from 'react';
import { Card, Typography, Tag, Space } from 'antd';
import { TemaCard } from 'src/data/models/TemaCardModel';

const { Text } = Typography;

interface MiniWordCardProps {
    card: TemaCard;
}

const MiniWordCard: React.FC<MiniWordCardProps> = ({ card }) => {
    return (
        <Card
            size="small"
            title={<Text strong style={{ fontSize: 16, textTransform: 'uppercase' }}>{card.spanish}</Text>}
        >
            {/* English translation */}
            <Text>
                <strong>English: </strong>
                <span>
                    {card.english}
                </span>
            </Text>

            {/* Related words section */}
            {card.related && card.related.length > 0 && (
                <div style={{ marginTop: 12 }}>
                    <Text type="secondary" style={{ fontSize: 12 }}>Related Words:</Text>
                    <Space wrap style={{ marginTop: 6 }}>
                        {card.related.map((rel, index) => (
                            <Tag
                                key={index}
                                color="#BCFCE7"
                                style={{ wordBreak: "break-word", whiteSpace: "normal", border: "1px solid rgba(63, 63, 63, 0.5)" }}
                            >
                                <p style={{
                                    color: "#40262d",
                                    margin: "0 auto",
                                    justifyContent: "center"
                                }} >
                                    <strong>{rel.spanish}</strong>-{rel.english}</p>
                            </Tag>
                        ))}
                    </Space>
                </div>
            )}
        </Card>
    );
};

export default MiniWordCard;
